export const Progress = {
    parts: [
        'label',
        'filledTrack',
        'track'
    ],
    baseStyle: {
        track: {
            bgColor: 'fill.light',
            borderRadius: '4px'
        }
    },
    variants: {
        ai: {
            filledTrack: {
                bg: 'background.ai'
            }
        },
        cyber: {
            filledTrack: {
                bg: 'background.cyber'
            }
        },
        data: {
            filledTrack: {
                bg: 'background.data'
            }
        },
        default: {
            filledTrack: {
                bg: 'background.brand'
            }
        },
        dv: {
            filledTrack: {
                bg: 'background.dv'
            }
        },
        mk: {
            filledTrack: {
                bg: 'background.mk'
            }
        },
        ml: {
            filledTrack: {
                bg: 'background.ml'
            }
        },
        ux: {
            filledTrack: {
                bg: 'background.ux'
            }
        },
        web: {
            filledTrack: {
                bg: 'background.web'
            }
        }
    },
    defaultProps: {
        size: 'sm',
        variant: 'default'
    }
};

//# sourceMappingURL=progress.js.map